import styles from "./RelatedInstitutions.module.scss";
import RelatedEntities from "Explore/Components/RelatedEntities";
import { getRelatedInstitutionsById } from "Explore/Services/Institution";
import useExploreInfo from "Hooks/useExploreInfo";
import { useEffect, useState } from "react";

const institutionCarouselResponsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 3,
    partialVisibilityGutter: 40,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
    partialVisibilityGutter: 40,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    partialVisibilityGutter: 40,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    partialVisibilityGutter: 30,
  },
};

const RelatedInstitutions = () => {
  const { entity_id: institution_id } = useExploreInfo();
  const [data, setData] = useState({ data: [], isLoading: true });

  useEffect(() => {
    setData({ data: [], isLoading: true });
    getRelatedInstitutionsById({ id: institution_id }).then((res) => {
      setData({ data: res.results, isLoading: false });
    });
  }, []);

  return data.data.length > 0 ? (
    <div className={styles["related-entities"]}>
      <h2 className={styles["related-entities--title"]}>Similar Institutions</h2>
      <RelatedEntities
        entities={data}
        entityType="institution"
        responsive={institutionCarouselResponsive}
      />
    </div>
  ) : (
    <></>
  );
};

export default RelatedInstitutions;

